// Vidéos YouTube et pièces jointes dans le contenu des articles.
//
// Dans l'éditeur, une vidéo est stockée comme une vignette :
//   <figure class="yt-embed" data-youtube="ID" data-start="30" contenteditable="false">…</figure>
// Sur le site, RichContent remplace cette vignette par le lecteur YouTube.

const YT_ID = /^[A-Za-z0-9_-]{11}$/;

// Reconnaît : youtube.com/watch?v=ID, youtu.be/ID, youtube.com/shorts/ID, /embed/ID, /live/ID,
// m.youtube.com, music.youtube.com, avec ou sans ?t=1m30s / &t=90 / ?start=90
export function parseYouTube(input) {
  if (!input) return null;
  let u;
  try { u = new URL(input.trim().startsWith('http') ? input.trim() : `https://${input.trim()}`); }
  catch { return null; }
  const host = u.hostname.replace(/^(www|m|music)\./, '');
  let id = null;
  if (host === 'youtu.be') id = u.pathname.slice(1).split('/')[0];
  else if (host === 'youtube.com' || host === 'youtube-nocookie.com') {
    if (u.pathname === '/watch') id = u.searchParams.get('v');
    else {
      const m = u.pathname.match(/^\/(shorts|embed|live|v)\/([^/?#]+)/);
      if (m) id = m[2];
    }
  }
  if (!id || !YT_ID.test(id)) return null;
  const t = u.searchParams.get('t') || u.searchParams.get('start') || '';
  return { id, start: parseTime(t) };
}

// "90", "90s", "1m30s", "1h2m3s" → secondes
function parseTime(t) {
  if (!t) return 0;
  if (/^\d+$/.test(t)) return Number(t);
  const m = t.match(/^(?:(\d+)h)?(?:(\d+)m)?(?:(\d+)s)?$/);
  return m ? (Number(m[1] || 0) * 3600 + Number(m[2] || 0) * 60 + Number(m[3] || 0)) : 0;
}

const esc = (s) => String(s).replace(/[&<>"']/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));

export function youtubeFigureHtml({ id, start }) {
  return `<figure class="yt-embed" data-youtube="${id}" data-start="${start || 0}" contenteditable="false">`
    + `<img src="https://i.ytimg.com/vi/${id}/hqdefault.jpg" alt="Vidéo YouTube">`
    + `<figcaption>▶ Vidéo YouTube${start ? ` (à partir de ${Math.floor(start / 60)} min ${start % 60} s)` : ''}</figcaption>`
    + `</figure><p><br></p>`;
}

export const formatSize = (bytes) => (bytes >= 1024 * 1024
  ? `${(bytes / 1024 / 1024).toFixed(1).replace('.', ',')} Mo`
  : `${Math.max(1, Math.round(bytes / 1024))} Ko`);

export function fileLinkHtml({ url, name, size, type }) {
  const icon = type === 'pdf' ? 'PDF' : 'DOC';
  return `<p><a class="file-link" data-type="${esc(type)}" href="${esc(url)}" target="_blank" rel="noopener">`
    + `<span class="file-link-icon">${icon}</span>`
    + `<span class="file-link-text"><span class="file-link-name">${esc(name)}</span>`
    + `<span class="file-link-size">${formatSize(size)} · ${type === 'pdf' ? 'ouvrir' : 'télécharger'}</span></span>`
    + `</a></p><p><br></p>`;
}

// Transforme le HTML enregistré pour l'affichage public (vignettes → lecteurs YouTube)
export function renderRichHtml(html) {
  if (!html || typeof DOMParser === 'undefined' || !html.includes('yt-embed')) return html || '';
  const doc = new DOMParser().parseFromString(`<div>${html}</div>`, 'text/html');
  doc.querySelectorAll('figure.yt-embed[data-youtube]').forEach(fig => {
    const id = fig.getAttribute('data-youtube');
    if (!YT_ID.test(id)) { fig.remove(); return; }
    const start = parseInt(fig.getAttribute('data-start'), 10) || 0;
    const wrap = doc.createElement('div');
    wrap.className = 'yt-player';
    const iframe = doc.createElement('iframe');
    iframe.src = `https://www.youtube-nocookie.com/embed/${id}${start ? `?start=${start}` : ''}`;
    iframe.title = 'Vidéo YouTube';
    iframe.setAttribute('loading', 'lazy');
    iframe.setAttribute('allow', 'accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share');
    iframe.setAttribute('referrerpolicy', 'strict-origin-when-cross-origin');
    iframe.setAttribute('allowfullscreen', '');
    wrap.appendChild(iframe);
    fig.replaceWith(wrap);
  });
  return doc.body.firstChild.innerHTML;
}
